import { api } from "@/lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** Pornește un job de imagine pe server și așteaptă rezultatul prin polling (evită timeout-ul proxy-ului la generări lungi). */
export async function runImageJob(kind, data, postId = null, { timeoutMs = 240000 } = {}) {
  const { data: start } = await api.post("/admin/image-jobs", { kind, data, post_id: postId });
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await sleep(3000);
    const { data: job } = await api.get(`/admin/image-jobs/${start.job_id}`);
    if (job.status === "done") return job.result;
    if (job.status === "failed") throw new Error(job.error || "Nu am putut genera imaginea.");
  }
  throw new Error("Generarea durează prea mult. Mai încearcă o dată.");
}
